export const ITEM_DELETED_EVENT = 'deleted';
export const ITEM_SAVED_EVENT = 'saved';
export const ITEM_AFFECTE_EVENT = 'affected';
export const ITEM_REJECTION_EVENT = 'rejected';
export const ITEM_REASON_SUBMITTED_EVENT = 'reason-submitted';
export const ITEM_EDITED_EVENT = 'edited';
export const ITEM_UPDATED_EVENT = 'ITEM_UPDATED';
